import queryString from 'query-string';

const urlParams = queryString.parse(location.search.slice(1));

window.number = urlParams.m as string;

if (performance) {
  window.navigationStart = performance.timing.navigationStart;
} else {
  window.navigationStart = Date.now() + 300;
}

window.getHotIframePath = (src: string) => {
  return process.env.HOT_DOMAIN
    ? src.replace(
        'https://www.4dmodel.com/SuperTwo/hot_online1/index.html#/',
        process.env.HOT_DOMAIN
      )
    : src;
};
